/* eslint-disable max-classes-per-file */

export class ExternVirkeskopStatus {
// eslint-disable-next-line sonarjs/public-static-readonly
    static ok = "Ok";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static ignorerad = "Ignorerad";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static varning = "Varning";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static fel = "Fel";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static fatal = "Fatal";
}

export class Constants {
// eslint-disable-next-line sonarjs/public-static-readonly
    static statuses = [
        ExternVirkeskopStatus.ok,
        ExternVirkeskopStatus.ignorerad,
        ExternVirkeskopStatus.varning,
        ExternVirkeskopStatus.fel,
        ExternVirkeskopStatus.fatal
    ];
}

export interface IExternVirkeskopSearchModel {
    externBeteckning: string;
    leverantorer: IExternVirkeskopLeverantor[];
    statusar: IExternVirkeskopStatus[];
    datumMottagen: string;
    datumUppdaterad: string;
}

export interface IExternVirkeskopLeverantor {
    namn: string;
    id?: number;
}

export interface IExternVirkeskopStatus {
    namn: string;
    id?: number;
}

export interface ISearchExternVirkeskopResponse {
    id: number;
    externBeteckning: string;
    externNamn: string;
    datakalla: string;
    externOrganisation: string;
    status: string;
    felmeddelande: string;
    forstaDokumentdatum: string;
    uppdateradDokumentdatum: string;
    planerare: string;
    planerareTelefon: string;
    dokument: ISearchExternVirkeskopDokumentResponse[];
    kontrakt: ISearchExternVirkeskopkontraktResponse;
}

export interface ISearchExternVirkeskopDokumentResponse {
    id: number;
    dokumentnyckel: string;
    updated: string;
}

export interface ISearchExternVirkeskopkontraktResponse {
    id: number;
    kontraktnummer: string;
    avtalId: string;
}

export interface IExternDokumentData {
    dokumentData: string;
    externBeteckning: string;
}

export class ExternVirkeskopViewModel {
    id: number;
    selected: boolean;
    externBeteckning: string;
    externNamn: string;
    datakalla: string;
    externOrganisation: string;
    status: string;
    felmeddelande: string;
    forstaDokumentdatum: string;
    uppdateradDokumentdatum: string;
    planerare: string;
    planerareTelefon: string;
    kontrakt: ISearchExternVirkeskopkontraktResponse;
    dokument: ISearchExternVirkeskopDokumentResponse[];

    constructor(dto: ISearchExternVirkeskopResponse) {
        this.id = dto.id;
        this.selected = false;
        this.externBeteckning = dto.externBeteckning;
        this.externNamn = dto.externNamn;
        this.externOrganisation = dto.externOrganisation;
        this.felmeddelande = dto.felmeddelande;
        this.forstaDokumentdatum = dto.forstaDokumentdatum;
        this.datakalla = dto.datakalla;
        this.planerare = dto.planerare;
        this.planerareTelefon = dto.planerareTelefon;
        this.status = dto.status;
        this.uppdateradDokumentdatum = dto.uppdateradDokumentdatum;
        this.kontrakt = dto.kontrakt;
        this.dokument = dto.dokument;
    }
}
